export default function BulkActionsModal({
  isOpen,
  selectedCount,
  bulkDate,
  onBulkDateChange,
  onReschedule,
  onExport,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content bulk-modal" onClick={(event) => event.stopPropagation()}>
        <h2>Actions sur la sélection</h2>
        <p className="bulk-modal-subtitle">
          {selectedCount} tâche{selectedCount > 1 ? 's' : ''} sélectionnée{selectedCount > 1 ? 's' : ''}
        </p>

        <div className="bulk-modal-block">
          <label htmlFor="bulk-date">Nouvelle date</label>
          <input id="bulk-date" type="date" value={bulkDate} onChange={onBulkDateChange} />
          <button type="button" className="selection-action-btn modal-main-btn" onClick={onReschedule}>Reporter la sélection</button>
        </div>

        <div className="bulk-modal-block">
          <label>Export</label>
          <button type="button" className="selection-export-btn" onClick={onExport}>Exporter la sélection en JSON</button>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
}
